(function() {
  const STORAGE_KEY = 'wishlist';

  function getWishlist() {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  }

  function saveWishlist(wishlist) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
  }

  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }

  function updateButtonState(btn, handle) {
    const icon = btn.querySelector('i');
    if (!icon) return;
    if (isInWishlist(handle)) {
      icon.setAttribute('class', 'fa-solid fa-heart');
      btn.classList.add('is-wishlisted');
    } else {
      icon.setAttribute('class', 'fa-regular fa-heart');
      btn.classList.remove('is-wishlisted');
    }
  }

  function toggleWishlist(e, btn, handle) {
    e.preventDefault();
    e.stopPropagation();
    const wishlist = getWishlist();
    const index = wishlist.indexOf(handle);
    if (index === -1) {
      wishlist.push(handle);
    } else {
      wishlist.splice(index, 1);
    }
    saveWishlist(wishlist);
    updateButtonState(btn, handle);
  }

  function initWishlistButtons() {
    document.querySelectorAll('.wishlist-btn').forEach(function(btn) {
      const handle = btn.getAttribute('data-product-handle');
      if (!handle) return;

      // 再レンダリング後も状態を毎回反映
      updateButtonState(btn, handle);

      if (btn.dataset.wishlistInit) return;
      btn.dataset.wishlistInit = '1';

      btn.addEventListener('click', function(e) {
        toggleWishlist(e, btn, handle);
      });
    });
  }

  // Impactテーマの再レンダリング（バリアント切替等）に追従
  const observer = new MutationObserver(function() {
    initWishlistButtons();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistButtons);
  } else {
    initWishlistButtons();
  }

  document.addEventListener('shopify:section:load', initWishlistButtons);

})();